import { render, staticRenderFns } from "./DraftInvendo.vue?vue&type=template&id=72512ca1&"
import script from "./DraftInvendo.vue?vue&type=script&lang=js&"
export * from "./DraftInvendo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports